"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return ["a", "aby", "albo", "albowiem", "ale", "bo", "bowiem", "czy", "gdy", "gdyby", "gdyż", "iż", "jeśli", "jeżeli", "lub", "ponieważ", "zanim", "żeby", "który", "która", "które", "którzy", "którego", "której", "których", "któremu", "którym", "którą", "którymi", "że"];
};